import { useEffect, useRef, useState } from "react";
import { useEventSearch } from "../../../../hooks/useEventSearch";
import { EventSearchResults } from "./EventSearchResults";
import {
    SearchTakeoverDialog,
    SearchTakeoverDialogContent,
} from "../../forms/SearchTakeoverDialog";

export const EventSearchMobile = ({ event }) => (
    <SearchTakeoverDialog
        DialogComponent={SearchDialog}
        dialogProps={{ event }}
        inputPlaceholder="Find competitors or divisions"
        dialogTitleId="event-search-dialog-title"
    />
);

export const SearchDialog = ({ event, closeDialog }) => {
    const {
        inputRef,
        loading,
        searchString,
        onSearch,
        searchResults,
        clearSearch,
    } = useEventSearch(event);
    const dialogContentRef = useRef();
    const [maxHeight, setMaxHeight] = useState(0);

    useEffect(() => {
        const updateHeight = () =>
            dialogContentRef.current &&
            setMaxHeight(
                dialogContentRef.current.getBoundingClientRect().height,
            );
        updateHeight();
        window.addEventListener("resize", updateHeight);
        return () => window.removeEventListener("resize", updateHeight);
    }, []);

    return (
        <SearchTakeoverDialogContent
            dialogTitleId="event-search-dialog-title"
            searchRef={inputRef}
            dialogContentRef={dialogContentRef}
            placeholder="Find competitors or divisions"
            search={searchString}
            loading={loading}
            onSearch={onSearch}
            closeDialog={closeDialog}
        >
            {!!searchString && (
                <EventSearchResults
                    eventId={event.id}
                    searchResults={searchResults}
                    clearSearch={clearSearch}
                    loading={loading}
                    maxHeight={maxHeight}
                />
            )}
        </SearchTakeoverDialogContent>
    );
};
